import clsx from 'clsx';

export function AsideContainer({
  children,
  className,
  ...asideProps
}: React.ComponentProps<'aside'>) {
  return (
    <aside
      className={clsx(
        'bg-almond-99 w-full lg:w-[375px] xl:w-[42%] py-6 sm:py-8 md:py-12 xl:pr-[calc(((100vw-1440px)/2)+2rem)]',
        className
      )}
      {...asideProps}
    >
      {children}
    </aside>
  );
}
